const ButtonLoader = () => {
  return (
    <span
      className='spinner-border spinner-border-sm btn-spinner'
      role='status'
      aria-hidden='true'
    ></span>
  );
};

export default ButtonLoader;
